import React, { createContext, useContext, useState } from 'react';
import { syncFromServer } from '../data/adapters/apiAdapter';

const SERVER          = '';   // 相对路径，由 CRA proxy 转发到 localhost:3001
const AUTH_SESSION_KEY = 'bjt_auth_session';

function readAuthSession() {
  try {
    const raw = localStorage.getItem(AUTH_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function persistSession(session) {
  try { localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session)); } catch {}
}

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(() => readAuthSession());

  async function register(username, password) {
    try {
      const res  = await fetch(`${SERVER}/api/auth/register`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!data.success) return { success: false, error: data.error };
      persistSession(data.user);
      setCurrentUser(data.user);
      await syncFromServer(data.user.id);
      return { success: true };
    } catch {
      return { success: false, error: '无法连接到服务器，请确认服务已启动（npm run server）' };
    }
  }

  async function login(username, password) {
    try {
      const res  = await fetch(`${SERVER}/api/auth/login`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!data.success) return { success: false, error: data.error };
      persistSession(data.user);
      setCurrentUser(data.user);
      await syncFromServer(data.user.id);
      return { success: true };
    } catch {
      return { success: false, error: '无法连接到服务器，请确认服务已启动（npm run server）' };
    }
  }

  function logout() {
    localStorage.removeItem(AUTH_SESSION_KEY);
    setCurrentUser(null);
  }

  return (
    <AuthContext.Provider value={{ currentUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
